<template>
  <div class="NewsShow">
    <div style="width: 980px;margin: auto;">
      <div class="title-box" v-html="title"></div>
      <!--      <el-button type="success" @click="admit">提交</el-button>-->
      <div>
        <div class="date-box1">{{this.companyName}} | 编辑：{{this.editor}} | 作者：{{this.author}}</div>
        <div class="date-box">发布时间：{{date}}</div>
      </div>
      <div v-if="this.isReprint==2" style="margin:100px 0 0 420px">请打开地址查看详情：</div>
      <div v-html="content" class="details-box" v-if="this.isReprint==2"></div>
      <div v-html="content" class="details-box1" v-if="this.isReprint==1"></div>
      <div style="text-align: right">
        <el-button @click="openPass(2)">通过</el-button>
        <el-button @click="openRefuse()">不通过</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import time from "@/core/time";
import {ElLoading} from "element-plus";
export default {
  created() {
  },
  mounted() {
    this.id = this.$route.query.id;
    this.filter();
  },
  data(){
    return{
      isReprint:'',
      id:null,
      date:'',
      content:'',
      title:'',
      fileList:[],
      companyName:'',
      editor:'',
      author:'',
    }
  },
  methods:{

    filter(){
      let data = {
        id:this.id,
      };
      let loadingInstance = null;
      loadingInstance = ElLoading.service({ fullscreen: true});
      this.$request.post('/ArNews/getNewsById',data).then(data => {
        console.log(data);
        this.companyName=data.obj.news.companyName;
        this.editor=data.obj.news.editor;
        this.author=data.obj.news.author;
        this.title =  data.obj.news.title;
        this.content = data.obj.news.content;
        this.isReprint=data.obj.news.isReprint;
        this.date = time.formateDate(data.obj.news.createdDate);
        loadingInstance.close();
      })
    },
    openRefuse() {
      this.$prompt('请输入审核建议', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputPattern: /\S/,
        inputErrorMessage:'内容不能为空',
      }).then(({ value }) => {
        console.log(value);
        let data= {
          advice:value,
          type:4,
          id:this.id,
        }
        this.$request.post("/ArNews/CheckNews",data).then((data) => {
          console.log("上传成功!")
        })
        this.$message({
          type: 'success',
          message: '提交审核成功 '
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消提交'
        });
      });
    },
    openPass() {
      this.$confirm('是否确认通过？', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
          .then(() => {
            console.log(3);
            let data = {
              type:3,
              id:this.id,
            };
            this.$request.post('/ArNews/CheckNews',data).then(data => {
              console.log("success!");
            })
            this.$message({
              type: 'success',
              message: '保存修改'
            });
          })
          .catch(action => {
            this.$message({
              type: 'info',
              message:'取消'
            })
          });
    },
  }
}
</script>

<style lang="less">
.NewsShow{
  width: 100%;
  height: 100%;
  a:link {color: black; text-decoration:none;} //未访问
  a:active {color: black; } //激活：红色
  a:visited {color:black;text-decoration:none;} //已访问
  a:hover {color: black; text-decoration:underline;} //鼠标移近
  .btn-back{
    border: none;
    font-size: 16px;
  }
  .title-box{
    text-align: center;
    font-size: 20px;
    margin: 60px 0 30px 0;
    font-weight: 800;
  }
  .date-box{
    font-size: 16px;
    color: #777777;
    text-align: right;
    padding-bottom: 48px;
    float: right;
  }
  .date-box1{
    font-size: 16px;
    color: #777777;
    text-align: left;
    padding-bottom: 48px;
    float: left;
  }
  .details-box{
    margin-top: 50px;
    font-size: 16px;
    line-height: 25px;
    text-align: left;
    img{
      //align:center;
      //max-width: 100%;
      //max-height: 700px;
    }

  }
  .details-box1{
    margin-top: 100px;
    font-size: 16px;
    line-height: 25px;
    text-align: left;
    img{
      align:center;
      max-width: 100%;
      max-height: 700px;
    }

  }

  .file-box{
    margin-top: 40px;
    padding-bottom: 50px;
  }
}
</style>